import { Flex, FloraTypography } from '@grupoboticario/flora-react';
import { isMobile } from 'core/use-cases/app/helpers';
import { Link } from 'react-router';
import { Container, Text } from 'ui/components/primitives';
import { ButtonShowAll } from 'ui/components/primitives/Heading/Heading.styles';
import { clickEvents } from 'ui/utilities/helpers/click-events';

const CycleGuideBotHeader = () => (
  <>
    <Container fluid marginTop="sp-12" marginBottom="sp-2">
      <Flex>
        <FloraTypography
          fontSize="subtitle"
          as="h6"
          css={{ color: '$medium-light-1', margin: 0 }}
          viewport={isMobile() ? 'mobile' : 'desktop'}
          onClick={() => {
            clickEvents('click:ver-tudo', 'interaction_catalogos', 'ciclo-atual');
          }}
        >
          Catálogos do ciclo
        </FloraTypography>
        <Link to="/catalogos-dos-ciclos">
          <ButtonShowAll>Ver tudo</ButtonShowAll>
        </Link>
      </Flex>
    </Container>
    <Container fluid marginTop="sp-0" marginBottom="sp-4">
      <Text color="medium-light-1" textAlign="left" variant="body-large-standard">
        Para compartilhar com seus clientes
      </Text>
    </Container>
  </>
);

export default CycleGuideBotHeader;
